// extracted by mini-css-extract-plugin
export default {"root":"Time_root__RJaKl","label":"Time_label__6yD-S","time":"Time_time__tZrzK","HH":"Time_HH__JlNhK","MM":"Time_MM__++nRT","SS":"Time_SS__LLpKg"};